import React from 'react';
import { PUBLIC_APP_ORIGIN } from '../api';

function ClubMembershipQr({ API, club, clubs, loading, membershipQr, setMembershipQr, showToast }) {
  return (
    <div className="w3-card w3-round w3-white w3-margin-bottom">
      <div className="w3-container w3-theme-d4 w3-round-top" style={{ padding: '12px 16px' }}>
        <span style={{ fontWeight: 700 }}><i className="fa fa-qrcode w3-margin-right"></i>Membership Form Links & QR</span>
      </div>
      <div className="w3-container w3-padding">
        <p className="w3-small w3-text-grey" style={{ marginTop: 0 }}>
          Share these direct links with members, or generate QR codes for posters and sign-in desks.
        </p>
        {(() => {
          const clubRef = encodeURIComponent((club && club.name ? String(club.name).trim() : String(club.id || '')).trim());
          return (
        <div className="w3-small" style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '6px', alignItems: 'center' }}>
          <span style={{ wordBreak: 'break-all' }}><strong>Apply:</strong> {PUBLIC_APP_ORIGIN}/membership/{clubRef}</span>
          <button className="w3-button w3-tiny w3-theme-l3 w3-round" onClick={() => navigator.clipboard.writeText(`${PUBLIC_APP_ORIGIN}/membership/${clubRef}`)}>
            <i className="fa fa-copy w3-margin-right"></i>Copy
          </button>
          <span style={{ wordBreak: 'break-all' }}><strong>Renew:</strong> {PUBLIC_APP_ORIGIN}/membership/{clubRef}/renew</span>
          <button className="w3-button w3-tiny w3-theme-l3 w3-round" onClick={() => navigator.clipboard.writeText(`${PUBLIC_APP_ORIGIN}/membership/${clubRef}/renew`)}>
            <i className="fa fa-copy w3-margin-right"></i>Copy
          </button>
        </div>
          );
        })()}

        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '10px' }}>
          <button className="w3-button w3-small w3-theme w3-round" disabled={membershipQr.loading}
            onClick={async () => {
              setMembershipQr(prev => ({ ...prev, loading: true }));
              try {
                const [applyRes, renewRes] = await Promise.all([
                  fetch(`${API}/api/auth/clubs/${club.id}/membership-qr?mode=apply&baseUrl=${encodeURIComponent(PUBLIC_APP_ORIGIN)}`),
                  fetch(`${API}/api/auth/clubs/${club.id}/membership-qr?mode=renew&baseUrl=${encodeURIComponent(PUBLIC_APP_ORIGIN)}`),
                ]);
                const applyData = await applyRes.json().catch(() => ({}));
                const renewData = await renewRes.json().catch(() => ({}));
                if (!applyRes.ok || !renewRes.ok) throw new Error(applyData.error || renewData.error || 'Failed to generate QR');
                setMembershipQr({ apply: applyData, renew: renewData, loading: false });
              } catch (err) {
                setMembershipQr(prev => ({ ...prev, loading: false }));
                showToast(err.message || 'Failed to generate QR', 'red');
              }
            }}>
            {membershipQr.loading ? <><i className="fa fa-spinner fa-spin w3-margin-right"></i>Generating...</> : <><i className="fa fa-qrcode w3-margin-right"></i>Generate QR Codes</>}
          </button>
        </div>

        {(membershipQr.apply || membershipQr.renew) && (
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginTop: '12px' }}>
            {membershipQr.apply && (
              <div className="w3-center">
                <img src={membershipQr.apply.qrCode} alt="Membership apply QR" style={{ width: 160, height: 160, border: '1px solid #ddd', borderRadius: 8 }} />
                <div className="w3-small" style={{ marginTop: 4 }}><strong>Apply</strong></div>
              </div>
            )}
            {membershipQr.renew && (
              <div className="w3-center">
                <img src={membershipQr.renew.qrCode} alt="Membership renew QR" style={{ width: 160, height: 160, border: '1px solid #ddd', borderRadius: 8 }} />
                <div className="w3-small" style={{ marginTop: 4 }}><strong>Renew</strong></div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ClubMembershipQr;
